import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { RightsContext } from 'providers/RightsContext';

export const WarrantyDataListSummary = ({ warranties, t, warrantyItemVisible }) => {
  let groupedWarranties = [];
  const { documentWarrantiesWrite } = useContext(RightsContext);

  warranties.forEach(item => {
    if (
      !groupedWarranties.some(
        p =>
          (warrantyItemVisible ? p.itemId === item.warrantyItem.itemId : p.itemId === item.dictionaryWarrantyTypeId) &&
          (item.currencyId ? p.currencyId === item.currencyId : p.currencyId === null)
      )
    ) {
      const filteredWarranties = warranties.filter(
        p =>
          (warrantyItemVisible
            ? p.warrantyItem.itemId === item.warrantyItem.itemId
            : p.dictionaryWarrantyTypeId === item.dictionaryWarrantyTypeId) &&
          (item.currencyId ? p.currencyId === item.currencyId : !p.currencyId)
      );

      groupedWarranties.push({
        itemId: warrantyItemVisible ? item.warrantyItem.itemId : item.dictionaryWarrantyTypeId,
        itemName: warrantyItemVisible ? item.warrantyItem.itemName : item.dictionaryWarrantyTypeName,
        currencyId: item.currencyId ? item.currencyId : null,
        currencyCode: item.currencyCode ? item.currencyCode : null,
        numberOfWarranties:
          item.qtty === null
            ? null
            : filteredWarranties.reduce(function (a, b) {
                return a + b.qtty;
              }, 0),
        amount:
          item.amount === null
            ? null
            : filteredWarranties.reduce(function (a, b) {
                return a + b.amount;
              }, 0)
      });
    }
  });

  return (
    <>
      {warranties?.length > 0 ? (
        groupedWarranties.map(item => {
          return (
            <Grid container spacing={1} key={item.itemId}>
              <Grid item xs={12}>
                {item.numberOfWarranties} x {item.itemName}{' '}
                {item.amount > 0
                  ? t('Document.Warranty.WarrantyAmountOnSummary', {
                      data: { amount: item.amount, currencyCode: item.currencyCode || '' }
                    })
                  : ''}
              </Grid>
            </Grid>
          );
        })
      ) : (
        <div> {documentWarrantiesWrite && warranties?.length === 0 ? t('ResultsNotFound') : t('NotApply')}</div>
      )}
    </>
  );
};

WarrantyDataListSummary.propTypes = {
  t: PropTypes.func.isRequired,
  warranties: PropTypes.array,
  warrantyItemVisible: PropTypes.bool
};

export default withTranslation()(memo(WarrantyDataListSummary));
